import { useEffect, useRef, ReactNode, JSX } from 'react';
import { createPortal } from 'react-dom';

interface UsePortalOptions {
    containerId?: string; // optional container ID
    bindTo?: HTMLElement; // optional DOM element to attach to directly
}
interface PortalProps {
    children: ReactNode;
}
interface UsePortalReturn {
    Portal: ({ children }: PortalProps) => JSX.Element;
    rootElem: HTMLElement;
}
export function usePortal({
    containerId,
    bindTo,
}: UsePortalOptions = {}): UsePortalReturn {
    const elRef = useRef<HTMLElement>(document.createElement('div'));
    useEffect(() => {
        const el = elRef.current;
        const parent =
            bindTo ||
            (containerId
                ? document.getElementById(containerId) || document.body
                : document.body);
        parent.appendChild(el);
        return () => {
            parent.removeChild(el);
        };
    }, [containerId, bindTo]);
    const Portal = ({ children }: PortalProps) => {
        return createPortal(children, elRef.current);
    };
    return { Portal, rootElem: elRef.current };
}
